// GlidePathAllocationWithEntry.js
import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
//import DOMPurify from 'dompurify';
//import './GlidePathAllocationWithEntry.css';

import GlidepathHeader from './GlidePathAllocation/GlidepathHeader';
import GlidepathStackedChartWithSlider from './GlidePathAllocation/GlidepathStackedChartWithSlider';
import GroupedAllocationTable from './GlidePathAllocation/GroupedAllocationTable';
import GlidepathDisclaimer from './GlidePathAllocation/GlidepathDisclaimer';
import GlidepathAllocationYearInputTextBox from './GlidePathAllocation/GlidepathAllocationYearInputTextBox';
import { toChartData, toTableData } from './GlidePathAllocation/ChartDataTransformer';

const GlidePathAllocationWithEntry = ({
    chartProductName = '',
    riskyAssetsLabel = '',
    defensiveAssetsLabel = '',
    GlidepathHeaderLabels = {},
    GlidepathStackedChartWithSliderLabels,
    GlidepathDisclaimerLabels,
    GroupedAllocationTableLabels,
    GlidepathAllocationYearInputTextBoxLabels,
    chartDataMaxYear,
    fundDataUrl,
    isTableExpandedByDefault,
    language,
}) => {
    const [fundData, setFundData] = useState(null);
    const [chartData, setChartData] = useState(null);
    const [inputValue, setInputValue] = useState({
        dataIndex: chartDataMaxYear,
        isReverseIndex: true,
    });

    const handleSubmitYear = useCallback((dataIndex, isReverseIndex = true) => {
        setInputValue({ dataIndex, isReverseIndex });
    }, []);

    const { t } = useTranslation();

    useEffect(() => {
        const fetchData = async () => {
            let baseUrl = process.env.REACT_APP_DATA_URL || '#{DATA_URL}';

            const fundResponse = await fetch(`${baseUrl}${fundDataUrl}`);

            if (!fundResponse.ok) {
                throw new Error('HTTP error!');
            }

            const fetchedFundDataArray = await fundResponse.json();

            const fundDataObject = Array.isArray(fetchedFundDataArray) ? fetchedFundDataArray[0] : fetchedFundDataArray;
            const transformedTableData = toTableData(fundDataObject);
            setFundData(transformedTableData);

            const transformedChartData = toChartData(fundDataObject);
            setChartData(transformedChartData);

            setTimeout(() => {
                window.applicationReInit(['IndividualFundsAccordion', 'LifecycleAllocation', 'FormSelect']);
            }, 100);
        };

        fetchData().catch((error) => console.error(error));

    }, [fundDataUrl, t]);

    if (!chartData || !fundData) {
        return <div>Loading...</div>;
    }

    return (
        <div className="l-container m-lifecycle-allocation u-margin-top-xl u-margin-bottom-xl"
            data-labels={JSON.stringify({
                chartlabel: chartProductName,
                riskyAssetsLabel: riskyAssetsLabel,
                defensiveAssetsLabel: defensiveAssetsLabel,
                totalLabel: t('overallLabel'),
                yearLabel: { year: t("yearLabel"), years: t("yearsLabel") },
                initialSliderLabel: t('initialSliderLabel'),
                stackedChartTooltipLabel: { year: t("stackedChartTooltipYearLabel"), years: t("stackedChartTooltipYearsLabel") }
            })}
            data-chart={JSON.stringify(chartData)}>

            <GlidepathHeader GlidepathHeaderLabels={GlidepathHeaderLabels} />
            <GlidepathAllocationYearInputTextBox onInputSubmit={handleSubmitYear} GlidepathAllocationYearInputTextBoxLabels={GlidepathAllocationYearInputTextBoxLabels} maxYear={chartDataMaxYear} />
            <GroupedAllocationTable fundData={fundData} inputValue={inputValue} GroupedAllocationTableLabels={GroupedAllocationTableLabels} isTableExpandedByDefault={isTableExpandedByDefault} language={language} />
            <GlidepathStackedChartWithSlider onInputSubmit={handleSubmitYear} GlidepathStackedChartWithSliderLabels={GlidepathStackedChartWithSliderLabels} maxYear={chartDataMaxYear} />
            <GlidepathDisclaimer GlidepathDisclaimerLabels={GlidepathDisclaimerLabels} fundData={fundData} />
        </div>
    )
}

export default GlidePathAllocationWithEntry;